import { render, staticRenderFns } from "./OpsMonitoringView.vue?vue&type=template&id=5a5856ba&scoped=true"
import script from "./OpsMonitoringView.vue?vue&type=script&lang=js"
export * from "./OpsMonitoringView.vue?vue&type=script&lang=js"
import style0 from "./OpsMonitoringView.vue?vue&type=style&index=0&id=5a5856ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5856ba",
  null
  
)

export default component.exports